<template>
  <div
    class="container p-3.5 lg:px-16 xl:px-16 mx-auto mt-2 relative"
    v-motion
    :initial="{ opacity: 0, x: -50, scale: 0.9 }"
    :enter="{ opacity: 1, x: 0, scale: 1 }"
    :hover="{ scale: 1.05, rotateY: 10 }"
    transition="{ stiffness: 50, damping: 15 }"
  >
    <!-- Mobile: Single card with auto-scrolling -->
    <div v-if="isMobile" class="swiper-container">
      <swiper
        :slides-per-view="1.5"
        :space-between="16"
        :centeredSlides="true"
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide v-for="(article, index) in articles" :key="index">
          <ArticleElement :article="article" />
        </swiper-slide>
      </swiper>
    </div>

    <div v-else-if="isTablet" class="swiper-container">
      <swiper
        :slides-per-view="2.5"
        :space-between="16"
        :modules="modules"
        :centeredSlides="true"
        class="mySwiper"
      >
        <swiper-slide v-for="(article, index) in articles" :key="index">
          <ArticleElement :article="article" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- Tablet and Desktop: Multiple cards with navigation -->
    <div v-else>
      <swiper
        :spaceBetween="10"
        :modules="modules"
        :slides-per-view="3.5"
        :space-between="16"
        class="mySwiper"
      >
        <swiper-slide v-for="(article, index) in articles" :key="index">
          <ArticleElement :article="article" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- "See All" link -->
    <a
      aria-label="Lien de blog"
      href="https://tunisiagotravel.com/blog"
      target="_blank"
      class="text-blue underline font-bold text-sm flex justify-center mt-4"
    >
      {{ $t('seeAll') }}
    </a>
  </div>
</template>
  
<script>
import ArticleElement from './ArticleElement.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation'; // Import styles for navigation
import { Navigation, Autoplay } from 'swiper/modules';

export default {
  components: {
    ArticleElement,
    Swiper,
    SwiperSlide,
  },
  props: {
    articles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  setup() {
    return {
      modules: [Navigation, Autoplay],
    };
  },
  methods: {
    handleResize() {
      const width = window.innerWidth;
      this.isMobile = width <= 600; // Mobile: <= 768px
      this.isTablet = width > 600 && width <= 1024; // Tablet: 769px - 1024px
    },
  },
  async mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style scoped>
.mySwiper {
  width: 100%;
  padding: 8px;
  height: 21rem;
}

@media (max-width: 1024px) {
  .mySwiper {
    height: 19rem;
  }
}
</style>